import type { CSSProperties, ReactNode } from 'react'

import { Scrollbar } from '@workwave-tidal/core/components'
import { useEffect, useRef } from 'react'

import { useComponentSize } from '@/local/hooks'

type Props = {
  height: number
  onUpdateHeight: (value: number) => void
  scrollBars?: boolean
  children?: ReactNode
  style?: CSSProperties
}

const defaultStyle = {
  padding: '0 32px',
  position: 'relative',
} as const

export function ModalBody(props: Props) {
  const { height, children = null, style: providedStyle = {}, onUpdateHeight } = props

  const compRef = useRef(null)
  const [dimensions] = useComponentSize(compRef, 100)

  const { height: dimensionY } = dimensions
  const style = { ...defaultStyle, ...providedStyle }

  useEffect(() => {
    if (dimensionY > 0) {
      onUpdateHeight(dimensionY)
    }
  }, [dimensionY, onUpdateHeight])

  return props.scrollBars ? (
    <div style={{ width: '100%', height }}>
      <Scrollbar hideOverflow="x">
        <div ref={compRef} style={style}>
          {children}
        </div>
      </Scrollbar>
    </div>
  ) : (
    <div style={style}>{children}</div>
  )
}
